import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function e164Validator(): ValidatorFn {
  const E164_REGEX = /^\+?[1-9]\d{1,14}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; // Don't validate empty values

    if (E164_REGEX.test(value)) {
      return null;
    } else {
      return {
        e164Invalid: {
          message: 'Phone number must be in E.164 format (e.g., +1234567890)'
        }
      };
    }
  };
}
